<template>

    <div class="container-fluid p-0">
        <div class="row m-0">
            <div class="col-12 p-0">
                <div class="login-card login-dark">
                    <div  class="login-main" >
                        <div><a class="logo"  >
                                <img class="img-fluid for-dark" src="../../../assets/images/logo/logo.png"
                                    alt="looginpage">
                                <img class="img-fluid for-light" src="../../../assets/images/logo/logo_dark.png"
                                    alt="looginpage"></a></div>
                        <div v-if="otpsent == 0">

                            <h4>Verify Yourself </h4>
                            <p>Enter Your Email ID</p>
                            <div class="form-group">
                                <label class="col-form-label">Email</label>
                                <input class="form-control" type="email"  v-model="mobileno"
                                    placeholder="Type Here..." required="">
                                    <p v-if="mob_error" class="text-danger">{{mob_error}} </p>
                            </div>

                            <div class="text-end mt-3">
                                <button class="btn btn-primary btn-block w-100" @click="sendOTP">Send OTP</button>
                            </div>
                            
                           

                        </div>
                        <div v-else>

                            <h4>Verify Yourself </h4>
                            <p  class="mb-0" >Enter OTP</p>
                            <p v-if="otpsent" class="text-danger">Otp Sent To {{mobileno}} </p>
                            <div class="form-group">
                                <label class="col-form-label">OTP Here</label>
                                <input class="form-control" type="number" v-model="otp" placeholder="Type Here..."
                                    required="">
                            </div>

                            <div class="text-end mt-3">
                                <button class="btn btn-primary btn-block w-100" @click="verifyOTP">Verify OTP</button>
                                <button class="btn btn-secondary btn-block w-100 mt-1" @click="editNumber()">Edit Email ID</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
                         <div class="mt-3 text-end ">
                                <router-link to="/login" class="text-muted">
                                  <i class="icofont icofont-shield"></i> 
                                </router-link>
                            </div>
        </div>
    </div>
</template>
<style scoped>
.login-card {
        padding-top: 0px !important;
     
    }
@media only screen and (max-width: 575.98px) {
    .login-card .login-main {
        /*width: 400px;*/
        /* padding: 20px; */
    }
}
.form-control{
        padding: 10px;
}
.page-body {
    margin-left: 0 !important;
    margin-top: 0px;
}

.user-profile .hovercard .cardheader {
    height: 100px;
    background: linear-gradient(45deg, #0437c8, #007611);
}

@media only screen and (max-width: 575.98px) {
    .tabs-scoial li:nth-child(3) {
        position: sticky;
    }
}
</style>

<script>
//import axios from 'axios'; 
import axios from "@/plugins/axios";
  
export default {
    name: 'register',
    components: {
    
    },
    mounted() {
        if (localStorage['_emp_token']) 
            this.$router.push({ name: "login" }); 
        else if(localStorage['token'])
            this.$router.push({ name: "visitorpage" }); 
        else
           this.$router.push({ name: "register" }); 


    },
    data() {
        return {
            mobileno: '',
            otpsent: 0,
            otp: '',
            mob_error:''
        }
    },
    methods: {
        acceptNumber() {
            var x = this.mobileno.toString().replace(/\D/g, '').match(/(\d{0,10})/);
            this.mobileno = x[1];

        },
   
        editNumber() {
            this.otpsent=0;

        },
    sendOTP() {
        var self = this;
           
           self.mobileno = self.mobileno.trim();
           const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
         if (emailPattern.test(self.mobileno)) {
            axios.post('sendVerificationCode', { mobileno: self.mobileno }).then(function (response) {
                if(response.data.is==1){
                    self.otpsent=1;
                    self.mob_error="";
                }
            });
        }else{
               self.mob_error = "Please enter a valid email address";
        }
    },
    verifyOTP() {
        var self = this;
        
        if ((self.otp+"").length>0) {
            axios.post('verifyCode', { mobileno: self.mobileno ,otp: self.otp }).then(function (response) {
                if(response.data.is==1){
                    localStorage.setItem('token', response.data.token);
                if(localStorage['_emp_token'])
                    localStorage.removeItem('_emp_token');
                    
                    if(response.data.userpic)
                        self.$router.push({ name: "visitorpage" }); 
                    else
                        self.$router.push({ name: "capture" }); 
                    
                    // if( response.data.userpic)
                    //     window.location.assign(window.location.origin + "/visitorpage");
                    // else
                    //     window.location.assign(window.location.origin + "/capture"); 
                }else{
                    self.$swal("Wrong OTP"); 
                }
                window.scrollTo(0, 0);
            });
        }else{
             self.$swal("Please Enter OTP"); 
        }
    },

}
}
</script>
